<template>
  <div>
    <div class="card border-secondary">
      <div class="card-header">
        <p class="card-title">Itens</p>
      </div>
      <div class="card-body p-2">
        <div class="scrollable-container">
          <div class="d-flex p-2 border-bottom justify-content-between align-items-center" v-for="(pedido, indice) in pedidos" :key="indice">
            <div class="mr-2 icone-container" v-if="pedido.produto_icone" >
              <b-img :src="obterIcone(pedido.produto_icone)" width="30" height="30" :class="{'icone': !ehProdutoMirt(pedido.produto_id) }" alt="Fluid image"></b-img>
            </div>
            <div class="flex-grow-1">
              <p class="m-0 badge-custom">
                {{ pedido.produto_nome }}
                <span v-if="pedido.cupom_aplicado" class="badge badge-success ml-2">Cupom aplicado</span>
              </p>
              <span class="text-muted small">{{pedido.descricao}}</span>
              <div class="m-0">
                <span class="text-bold">{{formatarValorMonetario(obterTotalPorPedido(pedido))}}</span>
                <span class="text-muted small ml-3">{{pedido.quantidade}} itens</span>
              </div>
              <p class="text-muted small" v-if="ehProporcional(indice, pedido)">
                O primeiro pagamento está sendo calculado proporcionalmente ao próximo vencimento do seu contrato que será em {{$date(dataVencimento).format('DD/MM/YYYY')}}.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card border-secondary" v-if="cupom_selecionado">
      <div class="card-header">
        <p class="card-title">Cupom</p>
      </div>
      <div class="card-body p-2">
        <div class="mt-2">
          <span class="card-text text-muted">Codigo: {{ cupom_selecionado.codigo_cupom }}</span>
        </div>
      </div>
    </div>
  </div>

</template>
<script>

import Resumo from './js/resumo'
export default Resumo
</script>

<style scoped>
.icone-container {
  background-color: #194175;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
}
.icone {
  filter: invert(1) sepia(1) saturate(5) hue-rotate(180deg);
}

.scrollable-container {
  max-height: 200px;
  overflow-y: auto;
}

.badge-custom .badge-success {
  background-color: #28a745;
  font-size: 13px !important;
}

</style>
